module.exports = __webpack_public_path__ + "img/account_role_template.7491300f.svg";